// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__uflbg","content":"ManualTimeModal_content__22Ol1"};